<div class="p-5">

  <div class="mb-4">
    <h1 class="text-sm font-semibold text-zinc-900">Integration Control</h1>
    <p class="mt-0.5 text-xs text-zinc-500">Monitor and manage third-party provider connections</p>
  </div>

  <div class="grid grid-cols-1 gap-3 md:grid-cols-2">
    <div
      *ngFor="let intg of integrations"
      class="flex flex-col gap-4 rounded-lg border bg-white p-4"
      [class.border-zinc-200]="intg.status !== 'error'"
      [class.border-red-200]="intg.status === 'error'"
      [class.bg-red-50]="intg.status === 'error'"
    >
      <!-- Header row -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-3">
          <div
            class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg"
            [ngClass]="intg.iconBg"
          >
            <lucide-icon [name]="intg.icon" [size]="16" [ngClass]="intg.iconColor" [strokeWidth]="1.75"></lucide-icon>
          </div>
          <div>
            <p class="text-sm font-semibold text-zinc-900">{{ intg.provider }}</p>
            <p class="text-xs text-zinc-400">{{ intg.detail }}</p>
          </div>
        </div>
        <span class="flex items-center gap-1.5 rounded px-2 py-0.5 text-[11px] font-medium" [ngClass]="statusBadge(intg.status)">
          <span class="h-1.5 w-1.5 rounded-full" [ngClass]="statusDot(intg.status)"></span>
          {{ intg.status | titlecase }}
        </span>
      </div>

      <!-- Stats row -->
      <div class="grid grid-cols-2 gap-3 border-t border-zinc-100 pt-3">
        <div>
          <p class="text-[10px] uppercase tracking-wide text-zinc-400">Orgs Connected</p>
          <p class="mt-0.5 text-sm font-semibold text-zinc-900">{{ intg.orgsConnected }}</p>
        </div>
        <div>
          <p class="text-[10px] uppercase tracking-wide text-zinc-400">Last Verified</p>
          <p class="mt-0.5 text-sm font-semibold text-zinc-900">{{ intg.lastVerified }}</p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex gap-2 border-t border-zinc-100 pt-3">
        <button
          *ngIf="intg.status === 'error'"
          class="flex items-center gap-1.5 rounded-md bg-red-600 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-red-700"
        >
          <lucide-icon name="refresh-cw" [size]="12" [strokeWidth]="2"></lucide-icon>
          Re-authenticate
        </button>
        <button
          *ngIf="intg.status !== 'error'"
          class="flex items-center gap-1.5 rounded-md border border-zinc-200 px-3 py-1.5 text-xs font-medium text-zinc-600 transition-colors hover:bg-zinc-50"
        >
          <lucide-icon name="refresh-cw" [size]="12" [strokeWidth]="1.75"></lucide-icon>
          Verify connection
        </button>
        <button
          class="flex items-center gap-1.5 rounded-md border border-zinc-200 px-3 py-1.5 text-xs font-medium text-zinc-600 transition-colors hover:bg-zinc-50"
        >
          <lucide-icon name="eye" [size]="12" [strokeWidth]="1.75"></lucide-icon>
          View details
        </button>
      </div>

    </div>
  </div>

</div>
